import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getClosings() {
    return axiosIns.get('/admin/cash_register_closings')
  },
  getClosing(id) {
    return axiosIns.get(`/admin/cash_register_closings/${id}`)
  },
  createOrFindDraft({ businessDate }) {
    return axiosIns.post(
      '/admin/cash_register_closings',
      snakecaseKeys({ businessDate }),
    )
  },
  updateClosing(id, {
    denominations, diffReasons, memo, nextDayReserveAmount, storageAmount,
  } = {}) {
    const payload = {}
    if (denominations) payload.denominations = denominations
    if (diffReasons) payload.diffReasons = diffReasons
    if (memo !== undefined) payload.memo = memo
    if (nextDayReserveAmount !== undefined) payload.nextDayReserveAmount = nextDayReserveAmount
    if (storageAmount !== undefined) payload.storageAmount = storageAmount

    return axiosIns.patch(
      `/admin/cash_register_closings/${id}`,
      snakecaseKeys(payload),
    )
  },
  finalizeClosing(id, { unresolvedReason } = {}) {
    return axiosIns.post(
      `/admin/cash_register_closings/${id}/finalize`,
      snakecaseKeys({ unresolvedReason }),
    )
  },
  unfinalizeClosing(id) {
    return axiosIns.post(`/admin/cash_register_closings/${id}/unfinalize`)
  },
  destroyClosing(id) {
    return axiosIns.delete(`/admin/cash_register_closings/${id}`)
  },
  getExpectedAmount({ businessDate }) {
    return axiosIns.get(
      '/admin/cash_register_closings/expected_amount',
      { params: snakecaseKeys({ businessDate }) },
    )
  },
  quickDeposit({ businessDate, amount, note }) {
    return axiosIns.post(
      '/admin/cash_register_closings/quick_deposit',
      snakecaseKeys({ businessDate, amount, note }),
    )
  },
  adjustOpeningBalance({ businessDate, actualBalance }) {
    return axiosIns.post(
      '/admin/cash_register_closings/adjust_opening_balance',
      snakecaseKeys({ businessDate, actualBalance }),
    )
  },
}
